import { useLazyQuery } from '@apollo/client/react';
import React, { useContext, useLayoutEffect } from 'react';
import { EarthLoader } from '../../components/loaders/EarthLoader';
import { PotreeSourcesContext } from '../../contexts/PotreeSourcesContext';
import { REQUEST_READ_SAS_TOKEN } from '../../graphql/project';
import { ProjectRequestReadSasTokenQuery, ProjectRequestReadSasTokenQueryVariables } from '../../types/graphqlTypes';
import { loadPointCloud } from '../../potree/Potree';
import { PointSizeType } from '../../potree/defines';
import { setProjectId, setStorageContainer } from '../../potree/potreeState';
import { Viewer } from '../../potree/viewer/viewer';

const PotreeRenderer: React.FC = () => {
  const { isLoaded: sourcesLoaded } = useContext(PotreeSourcesContext);
  const [projectRequestReadSASToken] = useLazyQuery<ProjectRequestReadSasTokenQuery, ProjectRequestReadSasTokenQueryVariables>(REQUEST_READ_SAS_TOKEN, { fetchPolicy: 'network-only' });

  const projectId = '123';

  useLayoutEffect(() => {
    if (!sourcesLoaded) return;
    const urlParams = new URLSearchParams(window.location.search);
    const pointCloudName = urlParams.get('pc');
    if (!pointCloudName) return;

    const loadPointCloudHeaderFiles = async () => {
      const SASUrl = await projectRequestReadSASToken({ variables: { projectId } });
      const SAStoken = SASUrl.data?.projectRequestReadSASToken || '';
      localStorage.setItem('SASToken_' + projectId, SAStoken);
      // Dev page: the fixed project is one from before containers were decoupled, so its container is its id.
      setProjectId(projectId);
      setStorageContainer(projectId);
      const viewer = window.viewer;
      loadPointCloud(`/${projectId}/${pointCloudName}.ppch?${SAStoken}`, `${pointCloudName}`, (e) => {
        e.pointcloud.projection = '+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs';
        viewer.scene.addPointCloud(e.pointcloud);
        const material = e.pointcloud.material;
        material.size = 1;
        material.pointSizeType = PointSizeType.ADAPTIVE;

        viewer.fitToScreen();
      });
    };

    const initializeViewer = (pointCloudName = '') => {
      const renderArea = document.getElementById('potree_render_area');
      if (!renderArea) return;
      const viewer = new Viewer(renderArea, { useDefaultRenderLoop: false });
      window.viewer = viewer;

      viewer.setEDLEnabled(true);
      viewer.setFOV(60);
      viewer.setPointBudget(3 * 1000 * 1000);
      viewer.loadSettingsFromURL();
      viewer.setDescription(pointCloudName);
      viewer.loadGUI();
      loadPointCloudHeaderFiles();
    };

    initializeViewer(pointCloudName);
  }, [projectRequestReadSASToken, sourcesLoaded]);

  return (
    <>
      {<EarthLoader />}
      <div className="relative w-full h-full">
        <div className="absolute top-0 left-0 w-full h-full potree_container">
          <div id="potree_render_area">
            <div id="olContainer" style={{ position: 'absolute', width: '100%', height: '100%' }}></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PotreeRenderer;
